// default in library-'i18nextLng'
// for testing/demo purpose, please use the following plugin, and use 'als-language' for OL_LANGUAGE_KEY to match
// https://chrome.google.com/webstore/detail/advanced-page-language-sw/mhgjlbolkmcookadjpolimbddngjgbol
export const OL_LANGUAGE_KEY = 'ol-language';
